import "./auth-shell.scss";

import { ADMIN } from "@core/model/const";
import { LocalProfile } from "@core/model/local-profile";
import { ApiToFormService } from "@core/services/api-to-form.service";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import { PROFILE } from "@core/utility/settings";
import { GetResponsePersonModel } from "@factory/model/query-model-person";
import { useQyGetPerson } from "@factory/query/person.query";
import StorageService from "@shared/services/storage.service";
import { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import { useAuthShellNavigation } from "./auth-shell-navigation";

export function AuthShell() {
  const location = useLocation();
  const naviage = useNavigate();
  const { getAuthUser } = useUserIdentityContext();
  const { headerElement, navigationElement } = useAuthShellNavigation();
  const { userCode } = getAuthUser();

  // PERSON API
  const handlePersonSuccess = (response: GetResponsePersonModel) => {
    if (response.data?.length === 0) {
      return;
    }
    const mappedData = ApiToFormService.MapProfile(response.data?.[0]);
    StorageService.save<LocalProfile>(PROFILE, mappedData);
  };
  useQyGetPerson(
    "",
    1,
    0,
    undefined,
    { code: userCode },
    !!userCode,
    handlePersonSuccess
  );

  useEffect(() => {
    // This runs every time the route changes
    const { slug } = getAuthUser();
    const paths = location.pathname.split("/").filter((x) => !!x);
    const domain = paths[0];

    if (domain !== slug && domain !== ADMIN) {
      naviage("404");
    }

    // You can add custom logic here, e.g. analytics, auth checks, etc.
  }, [location]);

  return (
    <div id="AuthShell" className="auth-shell">
      {headerElement}

      <section className="flex mt-4">
        {navigationElement}

        <section className="flex-1 bg-gray-50 rounded-lg mr-4 ml-4 md:ml-0 overflow-y-auto">
          <Outlet />
        </section>
      </section>
    </div>
  );
}

export default AuthShell;
